import { Flex, Table, Group, ActionIcon } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { YesNoDialog } from "components/YesNoDialog";
import { useState } from "react";

interface UsersListProps {
  users: any[];
  onUserChosen: (uid: string) => void;
  onUserDelete: (uid: string) => void;
}

export const UsersList = (props: UsersListProps) => {
  const { users, onUserChosen, onUserDelete } = props;

  const [opened, { open, close }] = useDisclosure(false);
  const [deletedUid, setDeletedUid] = useState("");

  const deleteUserDialog = (uid: string) => {
    setDeletedUid(uid);
    open();
  };

  const deleteUser = () => {
    onUserDelete(deletedUid);
  };

  return (
    <>
      <Flex direction="column" justify="space-between">
        <Table
          horizontalSpacing="md"
          verticalSpacing="xs"
          miw={700}
          highlightOnHover
          layout="fixed"
        >
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Name</Table.Th>
              <Table.Th>Email</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {users.map((user) => {
              const onUserClicked = () => {
                onUserChosen(user.uid);
              };
              return (
                <Table.Tr key={user.uid}>
                  <Table.Td onClick={onUserClicked}>{user.name}</Table.Td>
                  <Table.Td onClick={onUserClicked}>{user.email}</Table.Td>
                  <Table.Td>
                    <Group>
                      <ActionIcon onClick={onUserClicked}>
                        <IconEdit />
                      </ActionIcon>
                      <ActionIcon
                        style={{ zIndex: 10 }}
                        onClick={() => {
                          deleteUserDialog(user.uid);
                        }}
                      >
                        <IconTrash />
                      </ActionIcon>
                    </Group>
                  </Table.Td>
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </Flex>
      <YesNoDialog
        opened={opened}
        title="Delete User"
        question="Are you sure you want to delete this user?"
        onClose={close}
        onYes={deleteUser}
      />
    </>
  );
};
